import { Auth, Storage } from "aws-amplify";
import moment from "moment/moment";
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  extractDocument,
  fetchDocument,
  fetchLOBCodeList as fetchLOBCodeListData,
  fetchJSONFromS3,
  invokeLambdaWithRetry,
  logAudit,
  processUpload,
  signOutUser,
  storageResultToBlob,
} from "../../../services/Helper";
import {
  fetchSubmissionDocumentlist,
  fetchTemplateList as fetchTemplateListData,
} from "../../../classic/components/Utils/ExtractUtils";
import { getParameterFromManager } from "services/Utils";
import config from "aws-exports";
import { v4 as uuid } from "uuid";
import { createUiLogger } from "../../../logging/uiLogger";
import { resolveUploadSubmissionIdentifier } from "./uploadSubmissionIdentifier";
const console = createUiLogger("meaplatform/newui/components/ContextProvider/index.jsx");


export const ThemeContext = createContext(null);
const submissionIdentifierAllowedPattern = /^[A-Za-z0-9-]+(?:\s[A-Za-z0-9-]*)*$/;

function hasInvalidSubmissionIdentifierCharacters(value) {
  if (!value || value.trim().length === 0) return false;
  return /^\s|\s$/.test(value) || !submissionIdentifierAllowedPattern.test(value);
}

const resolveShowNewSubmissionButton = (uiConfig) => {
  if (uiConfig?.accessControl?.showNewSubmissionButton !== undefined) {
    return Boolean(uiConfig.accessControl.showNewSubmissionButton);
  }
  return true;
};

export const ThemeContextProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(false);
  const [user, setUser] = useState(null);
  const [chatbotAlign, setChatbotAlign] = useState(false);
  const toggleTheme = () => setIsDark((prev) => !prev);
  const changeChatbotAlign = () => setChatbotAlign((prev) => !prev);
  const [lobText, setLOBText] = React.useState("");
  const [storeTemplateName, setStoreTemplateName] = useState("");
  const [templateJson, setTemplateJson] = useState([]);
  const [templateName, setTemplateName] = useState([]);
  const [fetchClientTemplates, setFetchClientTemplates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const theme = isDark ? "dark" : "light";
  const [selectedGroup, setSelectedGroup] = useState("");
  const [userGroups, setUserGroups] = useState([]);
  const [userGroupsLoaded, setUserGroupsLoaded] = useState(false);
  const [filteredFetchClientTemplates, setFilteredFetchClientTemplates] =
    useState([]);
  const [userRole, setUserRole] = React.useState("");
  const [cognitoGroups, setCognitoGroups] = React.useState([]);
  const [documents, setDocuments] = useState([]);
  const [filteredTileViewDocs,setFilteredTileViewDocs] = useState([]);
  const [lobCodesList, setLobCodesList] = useState([]);
  const [storeWidgetName, setStoreWidgetName] = useState("");
  const [listOfLobs, setListOfLobs] = useState([]);
  const [confirmTemplateSave, setconfirmTemplateSave] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [onConfirmCallback, setOnConfirmCallback] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [tickedEntities, setTickedEntities] = useState(null); //for flicker issue change into null
  const [storeSelectedRule, setStoreSelectedRule] = useState({});
  const [storedNavigate, setStoredNavigate] = useState(null);
  const [activeStepName, setActiveStepName] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [templateJsonData, setTemplateJsonData] = useState(null);
  const [selectedTemplateRules, setSelectedtemplateRules] = useState({});
  const [extractToolData, setExtractToolData] = useState(null);
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const [rulesData, setRulesData] = useState({});
  const [templateCount, setTemplateCount] = useState(-1);
  const [maxTemplateAllowedCount, setMaxTemplateAllowedCount] = useState(null);
  const [tempStoreSelectedRule, setTempStoreSelectedRule] = useState({});
  const [searchText, setSearchText] = useState("");
  const [globalSearchtext, setGlobalSearchtext] = useState(false);
  let [searchMode, setSearchMode] = useState("Full");
  const [filterModalState, setFilterModalState] = useState({
    isOpen: false,
    activeColumnId: null,
  });
  const [displayElement, setDisplayElement] = useState(false);
  const [viewType, setViewType] = useState("card");
  const [procStatus, setProcStatus] = useState([]);
  const [clientSideFilters, setClientSideFilters] = useState({});
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [customerConfig, setCustomerConfig] = useState(null);
  const [durationInDays, setDurationInDays] = useState(7);
  const [isInitialDateSet, setIsInitialDateSet] = useState(false);
  const [dateRange, setDateRange] = useState([
    moment().subtract(durationInDays, "days").startOf("day").toDate(),
    moment().endOf("day").toDate(),
  ]);

  const displaySubHistFromDate = dateRange[0];
  const displaySubHistToDate = dateRange[1];
  const [submissionName, setSubmissionName] = useState("");
  const [submissionIdentifier, setSubmissionIdentifier] = useState("");
  const [enableSelectedTemplate, setEnableSelectedTemplate] = useState(false);
  const [lobCodeOptions, setLOBCodeOptions] = useState([]);
  const [assocCtryCodeOptions, setAssocCtryCodeOptions] = useState([]);
  const [showCountryCodes, setShowCountryCodes] = useState(false);
  const [lobCodeValidationEnabled, setLobCodeValidationEnabled] =
    useState(false);
  const [templateOptions, setTemplateOptions] = useState([]);
  var [mcUploadExt, setMCUploadExt] = useState(".xls,.xlsx");
  const [reprocTemplateName, setReprocTemplateName] = useState("");
  const [showModalSelectTemplate, setShowModalSelectTemplate] = useState(false);
  const [isChatbotEnabled, setIsChatbotEnabled] = useState(false);
  const [menuItems, setMenuItems] = useState({});
  const [showNewSubmissionButton, setShowNewSubmissionButton] = useState(false);
  const [isSubmissionModalOpen, setIsSubmissionModalOpen] = useState(false);
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);
  const [templateType, setTemplateType] = useState("");
  const [documentObj, setDocumentObj] = useState({
    document: { documentName: "" },
  });
  const [submitTemplateName, setSubmitTemplateName] = useState("");
  const [fetchLatestData, setFetchLatestData] = useState(false);
  const [enableTemplate, setEnableTemplate] = useState(false);
  const [openModalRowId, setOpenModalRowId] = useState(null);
  const [modalAttachments, setModalAttachments] = useState([]);
  const [template, setTemplate] = useState("");
  const [qaToolStatus, setQaToolStatus] = useState(false);
  const [defaultProcStatus, setDefaultProcStatus] = useState([]);
  const [updatedTableHeading, setUpdatedTableHeading] = useState({});
  const [modifiedManageCol, setModifiedManageCol] = useState({defaultColumnValues: [], isModified: false});
  const [columnHeader, setColumnHeader] = useState(false);
  const [utcTimeConvert,setUtcTimeConvert] = useState(null);
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [filterSearchResults, setFilterSearchResults] = useState(null);
  const filterPrevSearchTermRef = useRef("");
  const countryCodesCacheRef = useRef({ value: undefined, ts: undefined });
  const declineCodesCacheRef = useRef({ value: undefined, ts: undefined });
  const userGroupsCacheRef = useRef({ value: undefined, ts: undefined });
  const [filterSearchColumn, setFilterSearchColumn] = useState(null);
  const [declineCodeOptions, setDeclineCodeOptions] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
      products: [],
      statuses: [],
    });
  const [lobCode, setLOBCode] = useState("All");
   const [groupedPosition, setGroupedPosition] = useState({ top: 0, left: 0 });

  const initialFormState = {
    documentName: "",
    documentFullPath: "",
    uploadDate: "",
    processingStatus: "Uploaded",
    submittedby: "",
    uploadDocumentName: "",
    uploadDocumentFullPath: "",
    file: null,
    files: null,
    target: null,
  };
  const [formData, setFormData] = useState(initialFormState);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedUploadFile, setSelectedUploadFile] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedEntityDocPriorityList, setSelectedEntityDocPriorityList] =
    useState([]);
  const [originalTemplateSnapshot, setOriginalTemplateSnapshot] = useState(null);
  var allowedExtensions =
    ".pdf,.odt,.doc,.docx,.rtf,.ppt,.pptx,.xls,.xlsx,.msg,.eml,.jpg,.jpeg,.png,.mp4,.zip";
  var allowedSimpleExtensions =
    ".pdf,.odt,.doc,.docx,.rtf,.ppt,.pptx,.xls,.xlsx,.jpg,.jpeg,.png,.mp4";

  useEffect(() => {
    if (
      dateRange[1] &&
      dateRange[0] &&
      dateRange[1].getTime() < dateRange[0].getTime()
    ) {
      setDateRange([dateRange[1], dateRange[0]]);
    }
  }, [dateRange]);

  const fetchMenuItems = async () => {
    const filePath = `system/config/uiConfiguration.json`;
    try {
      const fileData = await fetchJSONFromS3(filePath);
      setShowNewSubmissionButton(resolveShowNewSubmissionButton(fileData));
      return fileData?.menuItems || {};
    } catch (error) {
      console.error("Failed to fetch UI configuration:", error);
      return {};
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const items = await fetchMenuItems();
      setMenuItems(items);
      setLoading(false);
    };
    loadData();
  }, []);

  const allItems = useMemo(
    () => [
      ...(menuItems.Ingestion?.items || []),
      ...(menuItems.Products?.items || []),
      ...(menuItems.Others?.items || []),
      ...(menuItems.Premium ? [menuItems.Premium] : []),
    ],
    [menuItems]
  );

  const businessProcessItems = useMemo(
    () => [...(menuItems.BusinessProcess?.items || [])],
    [menuItems]
  );

  const browserByApp = useMemo(
    () => [...(menuItems.BrowserByApp?.items || [])],
    [menuItems]
  );

  const ingestMyData = useMemo(
    () => [...(menuItems.IngestMyData?.items || [])],
    [menuItems]
  );

  useEffect(() => {
    const currentRouteConfig = allItems.find(
      (item) => item.route === location.pathname
    );

    const shouldEnableChatbot = currentRouteConfig?.chatBot === true;
    setIsChatbotEnabled(shouldEnableChatbot);
  }, [location.pathname, allItems, setIsChatbotEnabled]);

   const ensureAllProductsSelected = (lobList, labels) => {
    if (!lobList || lobList.length === 0) return;
    const productCodes = lobList.map((lob) => lob.LOBCode);
    const hasProducts = productCodes.some((code) => labels.includes(code));

    if (!hasProducts) {
      setSelectedLabels((prev) => [...new Set([...prev, ...productCodes])]);
    }
  };

    useEffect(() => {
      ensureAllProductsSelected(lobCodesList, selectedLabels);
    }, [lobCodesList]);

  function mergeByEntityName(arr1, arr2) {
    const map = new Map();
    arr1.forEach((item) => map.set(item.entityName, item));
    arr2.forEach((item) => {
      if (!map.has(item.entityName)) {
        map.set(item.entityName, item);
      }
    });
    return Array.from(map.values());
  }

  const handleClose = (url, navigationState) => {
    if (confirmTemplateSave && !isEditMode) {
      setOnConfirmCallback();
      setShowConfirm(true);
      setStoredNavigate(navigationState ? { url, state: navigationState } : url);
      return false;
    }
    return true;
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [isDark, theme]);

  const fetchLOBCodeList = async () => {
    const lobCodes = await fetchLOBCodeListData();
    setLobCodesList(lobCodes);
    return lobCodes;
  };

  const fetchData = async () => {
    try {
      const [templatesResp, userGrps, lobCodeOptionsResp, countryCodesResp, declCodeOptionsResp] = await Promise.all([
        fetchTemplateList(),
        fetchUserGroups(),
        fetchLOBCodeList(),
        fetchCountryCodes(),
        fetchDeclineCodeList(),
      ]);
      const templates = templatesResp ?? [];
      for (let i = 0; i < templates.length; i++) {
        if (templates[i].TemplateName.toLowerCase() === "default template") {
          setTemplateName([
            {
              value: templates[i].TemplateName,
              label: templates[i].TemplateName,
            },
          ]);
          break;
        }
      }
      setTemplateOptions(templates);
      setUserGroups(userGrps);
      setSelectedGroup(userGrps?.[0]?.group_id || "");

      const hasDefaultLOBCode = userGrps?.some(
        (item) => item?.LOBCode?.toLowerCase() === "default"
      );
      let filteredLobCodeOptions = lobCodeOptionsResp;
      if (!hasDefaultLOBCode) {
        const lobCodesToFilter = new Set(
          userGrps?.map((item) => item?.LOBCode)
        );
        filteredLobCodeOptions = filteredLobCodeOptions.filter((item) =>
          lobCodesToFilter.has(item?.LOBCode)
        );
      }
      setLOBCodeOptions(filteredLobCodeOptions);

      // Country Codes
      let countryCodes = (countryCodesResp ?? []).map((obj) => ({
        label: `${obj.countryCode} - ${obj.country}`,
        value: obj.countryCode,
      }));
      const hasDefaultCCCode = userGrps?.some(
        (item) => item?.CountryCode?.toLowerCase() === "default"
      );
      let filteredCountryCodeOptions = countryCodes;
      if (!hasDefaultCCCode) {
        const CountryCodesToFilter = new Set(
          userGrps?.map((item) => item?.CountryCode)
        );
        filteredCountryCodeOptions = filteredCountryCodeOptions.filter((item) =>
          CountryCodesToFilter.has(item?.value)
        );
      }
      setAssocCtryCodeOptions(filteredCountryCodeOptions);

      // Decline Codes
      let declCodeOptions = (declCodeOptionsResp ?? []).map((data) => ({
        label: data.DeclinedReason,
        value: data.DeclineCode,
      }));
      setDeclineCodeOptions(declCodeOptions);
    } catch (error) {
      console.error("Error in fetching data", error);
    }
  };

  useEffect(() => {
    fetchData();
    setupUserRole();
  }, []);

  async function setupUserRole() {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    setUser(user);
    const groups = user.signInUserSession?.idToken?.payload?.["cognito:groups"];
    if (groups !== undefined) {
      setCognitoGroups(Array.isArray(groups) ? groups : []);
      if (groups.includes("MEA_ADMIN")) {
        setUserRole("MEA_ADMIN");
      } else if (groups.includes("MEA_UNDERWRITER")) {
        setUserRole("MEA_UNDERWRITER");
      } else if (groups.includes("MEA_FINANCE")) {
        setUserRole("MEA_FINANCE");
      } else if (groups.includes("MEA_PROCESSORS")) {
        setUserRole("MEA_PROCESSORS");
      } else if (groups.includes("MEA_CORPORATE")) {
        setUserRole("MEA_CORPORATE");
      } else {
        setUserRole(String(groups || ""));
      }
    }
  }

  async function fetchTemplateList() {
    setLoading(true);
    try {
      const templateController = await getParameterFromManager(
        "TEMPLATE_CONTROLLER"
      );
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        target: "fetchTemplateList",
        access_token: user.signInUserSession.idToken.jwtToken,
        count: -1,
        rowStart: 0,
        pageSize: templateController.maxTemplatesAllowed,
        searchTemplate: "",
        mode: "like",
      };
      const init = {
        body: JSON.stringify(body),
      };
      const data = await invokeLambdaWithRetry("instanceHandlerLight", init);
      const clientTemplates = data?.templates;
      const sortedClientTemplates = clientTemplates?.sort(
        (a, b) => new Date(b.CreateDate) - new Date(a.CreateDate)
      );
      setFetchClientTemplates(sortedClientTemplates);
      setFilteredFetchClientTemplates(sortedClientTemplates);
      return data.templates;
    } catch (err) {
      console.error("err: ", err);
      return [];
    } finally {
      setLoading(false);
    }
  }

  async function resolveTemplateVersionNumber(templateName) {
    const normalizedTemplateName = templateName
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    if (!normalizedTemplateName) {
      return null;
    }
    if (normalizedTemplateName === "default template") {
      return null;
    }
    const hasVersionNumber = value =>
      value !== undefined && value !== null && value !== "";

    const templates = await fetchTemplateListData(
      undefined,
      maxTemplateAllowedCount || templateOptions?.length || 250,
      templateName
    );
    const matchedTemplate = templates?.find(template =>
      template?.TemplateName?.toString()?.trim()?.toLowerCase() ===
      normalizedTemplateName
    );
    if (hasVersionNumber(matchedTemplate?.TemplateVersionNumber)) {
      return matchedTemplate.TemplateVersionNumber;
    }

    const existingTemplate = templateOptions.find(template =>
      template?.TemplateName?.toString()?.trim()?.toLowerCase() ===
      normalizedTemplateName
    );
    return hasVersionNumber(existingTemplate?.TemplateVersionNumber)
      ? existingTemplate.TemplateVersionNumber
      : null;
  }

  async function fetchUserGroups() {
    try {
      const cache = userGroupsCacheRef.current;
      if (
        cache.value === undefined ||
        isCacheValid(cache.ts) === false
      ) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          access_token: user.signInUserSession.idToken.jwtToken,
          target: "fetchUserGroups",
        };
        const init = {
          body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        cache.value = Array.isArray(data?.response?.data?.listUserGroupDetails)
          ? data.response.data.listUserGroupDetails
          : [];
        cache.ts = new Date();
        setUserGroups(cache.value);
        setUserGroupsLoaded(true);
        return cache.value;
      } else {
        setUserGroups(cache.value);
        setUserGroupsLoaded(true);
        return cache.value;
      }
    } catch (err) {
      console.error(err);
      setUserGroups([]);
      setUserGroupsLoaded(true);
      return [];
    }
  }

  function isCacheValid(cacheValTs) {
    if (cacheValTs === undefined) {
      return false;
    }
    const now = new Date();
    const msBetweenDates = Math.abs(cacheValTs.getTime() - now.getTime());
    const secBetweenDates = msBetweenDates / 1000;
    if (secBetweenDates > 300) {
      return false;
    }
    return true;
  }

  async function fetchCountryCodes() {
    try {
      const cache = countryCodesCacheRef.current;
      if (
        cache.value === undefined ||
        isCacheValid(cache.ts) === false
      ) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          access_token: user.signInUserSession.idToken.jwtToken,
          target: "fetchCountryCodes",
        };
        const init = {
          body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        cache.ts = new Date();
        cache.value = data.response;
        return cache.value;
      } else {
        return cache.value;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function fetchDeclineCodeList() {
    try {
      const cache = declineCodesCacheRef.current;
      if (
        cache.value === undefined ||
        isCacheValid(cache.ts) === false
      ) {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
          access_token: user.signInUserSession.idToken.jwtToken,
          target: "listTriageDeclinedReasons",
        };
        const init = {
          body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        cache.ts = new Date();
        cache.value = data.response;
        return cache.value;
      } else {
        return cache.value;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  const initializeTemplateAndRules = async (templateName, status = "") => {
    const [lobText, ...rest] = templateName.split("-");
    const templateNameSave = rest.join("-");
    const lobTextName = lobText.toLowerCase();
    if (status) {
      setLOBText(lobText);
      setStoreTemplateName(`${lobText}-${templateNameSave}`);

      if (status !== "existing template") {
        let productFilePath = `templates/metadata/${lobTextName}-entity-metadata.json`;
        let productFileData = await fetchJSONFromS3(productFilePath);
        let defaultFilePath = `templates/metadata/default-entity-metadata.json`;
        let defaultFileData = await fetchJSONFromS3(defaultFilePath);
        let result = [];
        if (productFileData && defaultFileData) {
          result = mergeByEntityName(
            productFileData.entities,
            defaultFileData.entities
          );
        }
        if (!productFileData) {
          result = defaultFileData.entities;
        }

        const docpriorities = await fetchDocPrioritiesList(lobText);
        const updatedEntities = result?.map((entity) => ({
          ...entity,
          documentPrioritization: docpriorities || [],
        }));
        setTemplateJson(updatedEntities || []);
      }
    }

    await fetchTemplateJson(templateName, status);
    await fetchRulesFromS3(templateName, status, lobTextName);
  };

  const fetchDocPrioritiesList = async (lobText) => {
    const getLobName = listOfLobs.find(
      (item) =>
        item?.LOBCode?.toString().toLowerCase() ===
        lobText.toString().toLowerCase()
    );
    let lobName =
      getLobName !== undefined
        ? getLobName?.LOBCode?.toString().toLowerCase()
        : lobText?.toString().toLowerCase();
    let productFilePath = `templates/metadata/${lobName}-entity-metadata.json`;
    // Fetch the JSON file from S3
    let productFileData = await fetchJSONFromS3(productFilePath);

    let defaultFilePath = `templates/metadata/default-entity-metadata.json`;
    // Fetch the JSON file from S3
    let defaultFileData = await fetchJSONFromS3(defaultFilePath);

    let result = [];

    // Check if the file was successfully retrieved
    if (productFileData?.general === undefined) {
      result = defaultFileData?.general?.documentPrioritization;
    } else {
      result = productFileData?.general?.documentPrioritization;
    }
    return result;
  };

  const fetchTemplateJson = async (templateName, status) => {
    setLoading(true);
    try {
      const filterTemplateDetails = fetchClientTemplates.find(
        (item) => item.TemplateName === templateName
      );

      let templateJsonPath = filterTemplateDetails?.TemplatePath.replace(
        ".xlsx",
        ".json"
      );

      const s3Resp = await Storage.get(templateJsonPath, {
        download: true,
        cacheControl: "no-cache",
      });
      var json_data = await (await storageResultToBlob(s3Resp)).text();
      var data = JSON.parse(json_data);
      setTemplateJsonData(data[0]);
      const stepTitles = ["Entity Picker", "Configuration", "Preview"];
      let value;
      for (let i = data[0].length - 1; i >= 0; i--) {
        const row = data[0][i];
        const found = row?.find((obj) => stepTitles.includes(obj?.value));
        if (found) {
          value = found.value;
          break;
        }
      }

      if (!value) {
        const lastRow = data[0].slice(-1)[0];
        value = lastRow?.find((obj) => obj.value !== "")?.value;
      }

      const index = stepTitles.indexOf(value);
      setActiveStepName(value);
      setActiveStep(index === -1 ? 0 : index);
      // already created templates need to update the state here
      if (status) {
        let productTemplateRulesData = await fetchTemplateRulesFile(templateName);
        const convertRules = convertMacroRules(productTemplateRulesData);
        setStoreSelectedRule(convertRules);
        setTempStoreSelectedRule(convertRules);
        //templateType has no value means it is for new ui , it has value means classic ui
        if (!templateType) {
          const structured = data[0]
            .slice(1) // skip headers
            .map((row, _, arr) => {
              const headerRow = arr[0] ? data[0][0] : [];
              const getIndex = (headerName) =>
                headerRow.findIndex(
                  (col) =>
                    col.value.trim().toLowerCase() === headerName.toLowerCase()
                );

              const entityNameIndex = getIndex("Entity Name");
              const exampleDescriptionIndex = getIndex("Example/Description");
              const dataTypeIndex = getIndex("Data Type");
              const mandatoryIndex = getIndex("Mandatory");
              const documentPriorIndex = getIndex("Document Prioritization");

              const entityName = row[entityNameIndex]?.value?.trim() || "";
              if (!entityName) return null; // skip empty entity names

              const rulesFromConvert = convertRules[entityName];
              const documentPrior = row[documentPriorIndex]?.value
                ?.split(",")
                .map((item) => item.trim())
                .filter(Boolean);

              return {
                entityName,
                exampleDescription: row[exampleDescriptionIndex]?.value || "",
                dataType: row[dataTypeIndex]?.value
                  ? [row[dataTypeIndex].value]
                  : [],
                mandatory: row[mandatoryIndex]?.value || "false",
                rules: rulesFromConvert || {},
                documentPrioritization: documentPrior || [],
              };
            })
            .filter(Boolean);
          const selectedDocPrior = structured.map(
            ({ entityName, documentPrioritization }) => ({
              entityName,
              documentPrioritization,
            })
          );
          setSelectedEntityDocPriorityList(selectedDocPrior);
          setOriginalTemplateSnapshot(JSON.parse(JSON.stringify(structured)));
          if (status === "existing template") {
            setTemplateJson(structured);
          }
          return setTickedEntities(structured);
        } else {
          const result = data.flatMap((table) => {
            const headerRow = table[0];
            const entityNameIndex = headerRow.findIndex(
              (col) => col.value === "Entity Name"
            );
            const exampleDescIndex = headerRow.findIndex(
              (col) => col.value === "Example/Description"
            );

            // map the remaining rows
            return table
              .slice(1)
              .map((row) => ({
                entityName: row[entityNameIndex]?.value || "",
                exampleDescription: row[exampleDescIndex]?.value || "",
                dataType: [],
                mandatory: "false",
                rules: {},
                documentPrioritization: [],
              }))
              .filter((item) => item.entityName !== "");
          });
          return setTickedEntities(result);
        }
      }
    } catch (error) {
      console.error("Error fetching template JSON:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplateRulesFile = async (templateName) => {
    let productUiRulesFilePath = `templates/rules/${templateName}_ui_rules.json`;
    let productTemplateRulesData = await fetchJSONFromS3(productUiRulesFilePath);

    if (productTemplateRulesData) {
      return productTemplateRulesData;
    }

    let productRulesFilePath = `templates/rules/${templateName}_rules.json`;
    return await fetchJSONFromS3(productRulesFilePath);
  };

  const fetchRulesFromS3 = async (templateName, status, lobText) => {
    let productTemplateRulesData = await fetchTemplateRulesFile(templateName);
    setSelectedtemplateRules(productTemplateRulesData || []);

    if (status) {
      const getLobText = listOfLobs.find(
        (item) =>
          item?.LOBCode?.toString().toLowerCase() ===
          lobText.toString().toLowerCase()
      );
      let lobName =
        getLobText !== undefined
          ? getLobText?.LOBCode?.toString().toLowerCase()
          : lobText?.toString().toLowerCase();

      let productFilePathRules = `templates/rules/${lobName}-entity-rules.json`;
      // Fetch the JSON file from S3
      let productFileData = await fetchJSONFromS3(productFilePathRules);
      let defaultFilePath = `templates/rules/default-entity-rules.json`;
      // Fetch the JSON file from S3
      let defaultFileData = await fetchJSONFromS3(defaultFilePath);
      let result = [];
      if (productFileData && defaultFileData) {
        result = mergeMacroRules(productFileData, defaultFileData);
      }
      // Check if the file was successfully retrieved
      if (productFileData === null) {
        result = defaultFileData;
      }
      setRulesData(result?.macroRules || []);
    }
  };

  const convertMacroRules = (input) => {
    const output = {};
    const rulesArray = Array.isArray(input?.entities)
      ? input.entities
      : Array.isArray(input?.macroRules)
      ? input.macroRules
      : [];

    rulesArray.forEach((item) => {
      const { entityName, rules } = item;
      output[entityName] = { ...rules };
    });

    return output;
  };

  // Merge macroRules with priority to 'a'
  function mergeMacroRules(a, b) {
    // Create a map for quick lookup from 'a'
    const map = new Map();
    a?.macroRules?.forEach((rule) => map.set(rule.entityName, rule));

    // Add rules from 'b' only if not present in 'a'
    b?.macroRules?.forEach((rule) => {
      if (!map.has(rule.entityName)) {
        map.set(rule.entityName, rule);
      }
    });

    // Convert map values back to array
    return { macroRules: Array.from(map.values()) };
  }

  const isSubmissionIdentifierLobQualified = (candidateLobCode) => {
    if (!candidateLobCode) return false;
    const knownLobCodes = new Set(
      [...(lobCodeOptions || []), ...(userGroups || [])]
        .map((item) => item?.LOBCode?.toString().toLowerCase())
        .filter((lobCode) => lobCode && lobCode !== "default")
    );
    return knownLobCodes.has(candidateLobCode.toLowerCase());
  };

  const getFilteredTemplateOptions = () => {
    let filteredTemplateOptions = [];
    var subidparts = submissionIdentifier
      .split("-")
      .map((part) => part.toLowerCase());
    if (lobCodeValidationEnabled === true && showCountryCodes === true) {
      filteredTemplateOptions = templateOptions.filter((template) => {
        return userGroups.some((group) => {
          const templateNameLowerCase = template.TemplateName.toLowerCase();
          if (templateNameLowerCase.startsWith(`default`)) {
            return true;
          }
          if (
            group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP &&
            (templateNameLowerCase.startsWith(
              `${subidparts[0]}-${subidparts[1]}-`
            ) ||
              templateNameLowerCase.startsWith(`${subidparts[0]}-default`))
          ) {
            return true;
          }
          const lobCodeLowerCase = group.LOBCode.toLowerCase();
          const countryCodeLowerCase = group.CountryCode.toLowerCase();
          if (subidparts.length >= 1) {
            if (
              templateNameLowerCase.startsWith(`${subidparts[0]}-default`) &&
              (lobCodeLowerCase === subidparts[0] ||
                lobCodeLowerCase === "default")
            ) {
              return true;
            }
          }
          if (subidparts.length >= 2) {
            if (
              templateNameLowerCase.startsWith(
                `${subidparts[0]}-${subidparts[1]}-`
              ) &&
              (lobCodeLowerCase === subidparts[0] ||
                lobCodeLowerCase === "default") &&
              (countryCodeLowerCase === subidparts[1] ||
                countryCodeLowerCase === "default")
            ) {
              return true;
            }
          }
          return false;
        });
      });
    } else if (
      lobCodeValidationEnabled === true &&
      showCountryCodes === false
    ) {
      if (!isSubmissionIdentifierLobQualified(subidparts[0])) {
        filteredTemplateOptions = templateOptions;
      } else {
        const matchingTemplates = templateOptions.filter((template) => {
          return userGroups.some((group) => {
            const templateNameLowerCase = template.TemplateName.toLowerCase();

            if (
              group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP &&
              templateNameLowerCase.startsWith(`${subidparts[0]}-`)
            ) {
              return true;
            }

            const lobCodeLowerCase = group.LOBCode.toLowerCase();

            if (subidparts.length >= 1) {
              if (
                templateNameLowerCase.startsWith(`${subidparts[0]}-`) &&
                (lobCodeLowerCase === subidparts[0] ||
                  lobCodeLowerCase === "default")
              ) {
                return true;
              }
            }

            return false;
          });
        });

        filteredTemplateOptions = matchingTemplates;
      }
    } else if (
      lobCodeValidationEnabled === false &&
      showCountryCodes === true
    ) {
      filteredTemplateOptions = templateOptions.filter((template) => {
        return userGroups.some((group) => {
          const templateNameLowerCase = template.TemplateName.toLowerCase();
          if (templateNameLowerCase.startsWith(`default`)) {
            return true;
          }
          if (
            group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP &&
            templateNameLowerCase.startsWith(`${subidparts[0]}-`)
          ) {
            return true;
          }
          const countryCodeLowerCase = group.CountryCode.toLowerCase();
          if (subidparts.length >= 1) {
            if (
              templateNameLowerCase.startsWith(`${subidparts[0]}-`) &&
              (countryCodeLowerCase === subidparts[0] ||
                countryCodeLowerCase === "default")
            ) {
              return true;
            }
          }
          return false;
        });
      });
    } else if (
      lobCodeValidationEnabled === false &&
      showCountryCodes === false
    ) {
      filteredTemplateOptions = templateOptions;
    }
    if (lobCodeValidationEnabled === true && showCountryCodes === true) {
      filteredTemplateOptions = filteredTemplateOptions.filter(
        (template) =>
          template.TemplateName.toLowerCase() === "default template" ||
          template.TemplateName.toLowerCase().startsWith(
            `${subidparts[0]}-${subidparts[1]}-`
          )
      );
    }
    return filteredTemplateOptions;
  };

  const mapTemplateOptions = () => {
    const filteredTemplateOptions = getFilteredTemplateOptions();
    if (filteredTemplateOptions.length > 0 && templateName.length === 0) {
      setTemplateName([
        {
          value: filteredTemplateOptions[0].TemplateName,
          label: filteredTemplateOptions[0].TemplateName,
        },
      ]);
    }
    return filteredTemplateOptions;
  };

  function isInvalidSubmissionId(submissionIdentifier) {
    if (submissionIdentifier.trim().length === 0) return true;
    if (hasInvalidSubmissionIdentifierCharacters(submissionIdentifier)) return true;
    if (showCountryCodes === true) {
      //The submission Identifier would be of the format lobcode-countrycode-subid value if the "Enable Country Code Validation" is enabled.
      var subidparts = submissionIdentifier.split("-");
      if (subidparts.length < 3) {
        return true;
      }
      var ctryCode = assocCtryCodeOptions.filter((obj) => {
        return obj.value.toLowerCase() === subidparts[1].toLowerCase();
      });
      if (ctryCode === undefined || ctryCode.length !== 1) {
        return true;
      }
      var lobCode = lobCodeOptions.filter((obj) => {
        return obj.LOBCode.toLowerCase() === subidparts[0].toLowerCase();
      });
      if (
        lobCode === undefined ||
        lobCode.length !== 1 ||
        lobCode[0].AssocCountryCodes === null ||
        lobCode[0].AssocCountryCodes === undefined ||
        lobCode[0].AssocCountryCodes.toLowerCase()
          .split(",")
          .includes(ctryCode[0].value.toLowerCase()) === false
      ) {
        return true;
      }
    }
    return false;
  }

  function isAllowedExtension(filePath, processed) {
    var filePathParts = filePath.toLowerCase().split(".");
    if (processed === true) {
      if (
        mcUploadExt
          .split(",")
          .map((i) => i.trim())
          .includes(`.${filePathParts[filePathParts.length - 1]}`) === true
      ) {
        return true;
      }
    } else if (
      allowedExtensions
        .split(",")
        .map((i) => i.trim())
        .includes(`.${filePathParts[filePathParts.length - 1]}`) === true
    ) {
      return true;
    }
    return false;
  }

  function disallowSubmission(file, files) {
    if (file === null && files === null) {
      return true;
    }
    if (file !== null) {
      if (isAllowedExtension(file.name) === false) {
        return true;
      }
    }
    if (files !== null) {
      for (var i = 0; i < files.length; i++) {
        if (isAllowedExtension(files[i].name) === false) return true;
      }
    }
    return false;
  }

  const filteredUserGroups = () => {
    let filteredUg = [];
    let templateList =
      templateName?.map((item) => item?.value?.toLowerCase()) || [];
    var subidparts = submissionIdentifier
      ?.split("-")
      .map((part) => part.toLowerCase());
    if (lobCodeValidationEnabled === true && showCountryCodes === true) {
      filteredUg = userGroups.filter((group) => {
        if (group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP)
          return true;
        const countryCodeLowerCase = group.CountryCode.toLowerCase();
        const lobCodeLowerCase = group.LOBCode.toLowerCase();
        if (
          countryCodeLowerCase !== "default" &&
          lobCodeLowerCase !== "default"
        ) {
          return (
            templateName.length > 0 &&
            templateList?.every(
              (templateNameLowerCase) =>
                templateNameLowerCase.startsWith(
                  `${lobCodeLowerCase}-${countryCodeLowerCase}-`
                ) ||
                templateNameLowerCase.startsWith(
                  `${lobCodeLowerCase}-default`
                ) ||
                (lobCodeLowerCase === subidparts[0] &&
                  countryCodeLowerCase === subidparts[1])
            )
          );
        } else if (
          countryCodeLowerCase === "default" &&
          lobCodeLowerCase === "default"
        ) {
          return true;
        } else if (countryCodeLowerCase === "default") {
          return (
            templateName.length > 0 &&
            templateList?.every(
              (templateNameLowerCase) =>
                templateNameLowerCase.startsWith(`${lobCodeLowerCase}-`) ||
                lobCodeLowerCase === subidparts[0]
            )
          );
        } else {
          //if (lobCodeLowerCase === "default")
          return (
            templateName.length > 0 &&
            templateList?.every(
              (templateNameLowerCase) =>
                templateNameLowerCase.startsWith(`${countryCodeLowerCase}-`) ||
                countryCodeLowerCase === subidparts[1]
            )
          );
        }
      });
    } else if (
      lobCodeValidationEnabled === true &&
      showCountryCodes === false
    ) {
      filteredUg = userGroups.filter((group) => {
        const lobCodeLowerCase = group.LOBCode.toLowerCase();
        if (lobCodeLowerCase === "default") {
          return true;
        } else {
          return (
            group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP ||
            (templateName.length > 0 &&
              templateList?.every((templateNameLowerCase) =>
                templateNameLowerCase.startsWith(`${group.LOBCode}-`)
              )) ||
            lobCodeLowerCase === subidparts[0]
          );
        }
      });
    } else if (
      lobCodeValidationEnabled === false &&
      showCountryCodes === true
    ) {
      filteredUg = userGroups.filter((group) => {
        const countryCodeLowerCase = group.CountryCode.toLowerCase();
        if (countryCodeLowerCase === "default") {
          return true;
        } else {
          return (
            group.group_id === import.meta.env.VITE_DEFAULT_USER_GROUP ||
            (templateName.length > 0 &&
              templateList?.every((templateNameLowerCase) =>
                templateNameLowerCase.startsWith(`${group.CountryCode}-`)
              )) ||
            countryCodeLowerCase === subidparts[0]
          );
        }
      });
    } else if (
      lobCodeValidationEnabled === false &&
      showCountryCodes === false
    ) {
      filteredUg = userGroups;
    }
    if (filteredUg.length > 0 && selectedGroup !== filteredUg[0].group_id) {
      setSelectedGroup(filteredUg[0].group_id);
    }
    return filteredUg;
  };

  async function reprocessDocument(inpDocument, templateName) {
    try {
      setLoading(true);
      var today = new Date();
      var nDate = today.toJSON().slice(0, 10); //YYYY-MM-DD
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        access_token: user.signInUserSession.idToken.jwtToken,
        target: "getLastMergedSeq",
        submissionIdentifier: inpDocument.submissionIdentifier,
      };
      const init = {
        body: body,
      };
      let res = await invokeLambdaWithRetry("instanceHandler", init);
      var origInfo = await fetchDocument(inpDocument.origin_document_id);
      var document_id = uuid();
      let document = {
        document_id: document_id,
        submissionIdentifier: inpDocument.submissionIdentifier.toUpperCase(),
        documentName: inpDocument.documentName,
        documentFullPath: inpDocument.documentFullPath,
        uploadDate: nDate,
        processingStatus: "Uploaded",
        submittedby: user.username,
        domainForDoc: origInfo.domainForDoc,
        downloadCount: 0,
        templateName: templateName,
        origin_document_id: inpDocument.origin_document_id,
        origin: origInfo.origin === "user-plain" ? "user-plain" : "merge",
        group_id: origInfo.group_id,
      };
      const templateVersionNumber =
        await resolveTemplateVersionNumber(templateName);
      if (templateVersionNumber !== null) {
        document.TemplateVersionNumber = templateVersionNumber;
      }
      var filePathParts = inpDocument.documentFullPath.toLowerCase().split(".");
      if (
        allowedSimpleExtensions
          .split(",")
          .map((i) => i.trim())
          .includes(`.${filePathParts[filePathParts.length - 1]}`) === false
      ) {
        document.isMerged = res + 1;
      }
      var documentEscaped = { ...document };
      documentEscaped.submissionIdentifier =
        documentEscaped.submissionIdentifier
          .replace(/'/g, "''")
          .replace(/"/g, '\\"');
      documentEscaped.documentName = documentEscaped.documentName
        .replace(/'/g, "''")
        .replace(/"/g, '\\"');
      documentEscaped.documentFullPath = documentEscaped.documentFullPath
        .replace(/'/g, "''")
        .replace(/"/g, '\\"');
      res = await createDocument(documentEscaped);
      if (
        allowedSimpleExtensions
          .split(",")
          .map((i) => i.trim())
          .includes(`.${filePathParts[filePathParts.length - 1]}`) === false
      ) {
        extractDocument(
          document,
          "reproc-template",
          undefined,
          undefined,
          undefined,
          undefined,
          reprocTemplateName !== "" ? reprocTemplateName : templateName,
          origInfo.group_id
        );
      } else {
        extractDocument(
          document,
          "reproc-template-simple",
          undefined,
          undefined,
          undefined,
          undefined,
          reprocTemplateName !== "" ? reprocTemplateName : templateName,
          origInfo.group_id
        );
      }
      logAudit(
        document_id,
        documentEscaped.submissionIdentifier,
        "Submission",
        "Reprocess Template",
        "UI",
        undefined,
        undefined,
        undefined,
        { isGlobalRecord: 1, documentName: documentEscaped.documentName }
      ).then((data) => {});
      setShowModalSelectTemplate(false);
    } finally {
      setLoading(false);
    }
  }

  async function createDocument(createDocumentsInput) {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const body = {
        access_token: user.signInUserSession.idToken.jwtToken,
        target: "createDocument",
        createDocumentsInput: createDocumentsInput,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      return data.response;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  const resetSubmissionUploadState = () => {
    setSubmissionName("");
    setSubmissionIdentifier("");
    setTemplateName([]);
    setSubmitTemplateName("");
    setTemplate("");
    setSelectedTemplate("");
    setSelectedFileName("");
    setSelectedUploadFile("");
    setSelectedGroup("");
    setFormData(initialFormState);
    setEnableTemplate(false);
    setEnableSelectedTemplate(false);
  };

  const handleFileUploads = async () => {
    resetSubmissionUploadState();
    setIsSubmissionModalOpen((prev) => !prev);
  };

  const isMulti =
    selectedFileName &&
    Array.from(selectedFileName)?.every(
      (file) => ![".zip"].some((ext) => file.name.endsWith(ext))
    );

  async function refreshSessionIfNeeded() {
    try {
      const session = await Auth.currentSession();
      const { exp } = session.getAccessToken().decodePayload();
      const currentTime = Math.floor(new Date().getTime() / 1000);
      if (exp < currentTime) {
        // Check if the token is already expired
        await Auth.currentAuthenticatedUser({ bypassCache: true });
      }
    } catch (err) {
      console.error("Error:- ", err);
    }
  }

  async function validateDocuments(e) {
    e.preventDefault();
    let templateList = templateName?.map((list) => list.value) || [];
    let subId = submissionIdentifier
      .split("-")
      .map((part) => part.toLowerCase());
    if (lobCodeValidationEnabled === true && showCountryCodes === false) {
      templateList = templateList
        .map((template) => {
          const checkDefaultTemp = getFilteredTemplateOptions().find(
            (template) =>
              template.TemplateName.toLowerCase() ===
                `${subId[0]}-default template` ||
              template.TemplateName.toLowerCase() ===
                `${subId[0]}-defaulttemplate`
          );
          if (template.toLowerCase() === "default template") {
            return checkDefaultTemp?.TemplateName;
          }
          return template;
        })
        .filter(Boolean)
        .filter((template, index, self) => index === self.indexOf(template));
    } else if (lobCodeValidationEnabled === true && showCountryCodes === true) {
      templateList = templateList
        .map((template) => {
          const checkDefaultTemp = getFilteredTemplateOptions().find(
            (template) =>
              template.TemplateName.toLowerCase() ===
                `${subId[0]}-${subId[1]}-default template` ||
              template.TemplateName.toLowerCase() ===
                `${subId[0]}-${subId[1]}-defaulttemplate`
          );
          if (template.toLowerCase() === "default template") {
            return checkDefaultTemp?.TemplateName;
          }
          return template;
        })
        .filter(Boolean)
        .filter((template, index, self) => index === self.indexOf(template));
    }
    templateList = templateList.filter(Boolean);
    const useSubmitTemplateName =
      Boolean(submitTemplateName) && templateList.length === 0;
    const uploadTemplateList = useSubmitTemplateName
      ? [submitTemplateName]
      : templateList;
    try {
      setLoading(true);
      if (
        (!formData.documentName ||
          !formData.documentFullPath ||
          formData.file === null) &&
        formData.files === null
      )
        return;
      try {
        if (!useSubmitTemplateName) {
          const allowedTemplateNames = new Set(
            getFilteredTemplateOptions()
              .filter(
                (template) =>
                  template.Status === "Complete" || template.Status === null
              )
              .map((template) => template.TemplateName.toLowerCase())
          );
          const invalidTemplateSelections = uploadTemplateList.filter(
            (template) => !allowedTemplateNames.has(template.toLowerCase())
          );
          if (
            uploadTemplateList.length === 0 ||
            invalidTemplateSelections.length > 0
          ) {
            setShowModalMsg(
              `Selected template is not valid for submission ${submissionIdentifier}. Please select a template again.`
            );
            setShowModal(true);
            setTemplateName([]);
            setTemplate("");
            setSelectedTemplate("");
            setEnableSelectedTemplate(false);
            return;
          }
        }
        const resolvedSubmissionIdentifier = resolveUploadSubmissionIdentifier(
          submissionIdentifier,
          uploadTemplateList,
          useSubmitTemplateName,
        );
        // Ensure the session is still valid, and refresh if needed
        await refreshSessionIfNeeded();
        var inputFiles = [];
        var documentFullPath;
        if (formData.files === null) {
          documentFullPath = `${resolvedSubmissionIdentifier}/${uuid()}/${uuid()}${
            formData.documentName
          }`;
          await Storage.put(documentFullPath, formData.file, {
            metadata: {
              source: "UI",
            },
          });
          await Storage.put(`info-staging/ui/${documentFullPath}`, "");
          inputFiles.push({
            documentName: formData.documentName,
            documentFullPath: documentFullPath,
          });
        } else {
          for (var i = 0; i < formData.files.length; i++) {
            documentFullPath = `${resolvedSubmissionIdentifier}/${uuid()}/${uuid()}${
              formData.files[i].name
            }`;
            await Storage.put(documentFullPath, formData.files[i], {
              metadata: {
                source: "UI",
              },
            });
            await Storage.put(`info-staging/ui/${documentFullPath}`, "");
            inputFiles.push({
              documentName: formData.files[i].name,
              documentFullPath: documentFullPath,
            });
          }
        }

        const result = await processUpload(
          resolvedSubmissionIdentifier,
          uploadTemplateList,
          inputFiles,
          selectedGroup,
        );
        if (result.disableUpload !== undefined) {
          // setDisableUpload(result.disableUpload);
        }
        if (result.allow === false) {
          setShowModalMsg(result.message);
          setShowModal(true);
          setIsSubmissionModalOpen(false);
          return;
        }

        var docResult = await fetchSubmissionDocumentlist({
          submissionIdentifier: resolvedSubmissionIdentifier,
        });

        const shouldBypassReprocessForUpload = Array.from(inputFiles || []).some(
          (file) =>
            [".eml", ".msg", ".zip"].some((ext) =>
              String(file?.documentName || file?.name || file?.documentFullPath || "")
                .toLowerCase()
                .endsWith(ext),
            ),
        );

        if (uploadTemplateList?.length > 1 && !shouldBypassReprocessForUpload) {
          for (let i = 1; i < uploadTemplateList.length; i++) {
            docResult?.length > 0 &&
              docResult?.forEach(
                async (list) =>
                  await reprocessDocument(list, uploadTemplateList[i])
              );
          }
        }

        if (!showModal) {
          if (useSubmitTemplateName || selectedTemplate) {
            setSearchText("");
            setSearchMode("Full");
            navigate("/user/submission-summary", {
              state: { skipInitialLoader: true },
            });
          }
          handleFileUploads();
          if (!submitTemplateName || !selectedTemplate) {
            setTimeout(() => setFetchLatestData((prev) => !prev), 1000);
          }
        }
      } catch (err) {
        if (err === "The user is not authenticated") {
          signOutUser();
        } else if (err?.message?.startsWith("The provided token has expired")) {
          // Attempt to refresh the session and retry
          await refreshSessionIfNeeded();
          await validateDocuments(e); // Retry the operation
        } else {
          console.error("error: ", err);
        }
      }
      formData.target = "";
      setFormData(initialFormState);
      setDocuments([...documents, formData]);
      setFilteredTileViewDocs(documents?.length > 0 ? documents : null)
      setEnableTemplate(false);
      setSelectedUploadFile("");
      setEnableSelectedTemplate(false);
    } finally {
      setIsSubmissionModalOpen(false);
      closeUploadModal();
      setLoading(false);
    }
  }

  const closeUploadModal = () => {
    setIsModalOpen(false);
    setOpenModalRowId(null);
    setModalAttachments([]);
    setSubmissionIdentifier("");
    setFormData(initialFormState);
    setSelectedUploadFile("");
    setSelectedTemplate("");
    setTemplate("");
    setEnableSelectedTemplate(false);
    setSubmissionName("");
  };

  useEffect(() => {
    let isMounted = true;

    async function loadCustomerConfig() {
      try {
        const configPath = "system/config/meaOpsConfig/customer.json";
        const resolvedConfig = await fetchJSONFromS3(configPath);
        if (!isMounted) return;

        setCustomerConfig(resolvedConfig || null);
      } catch (error) {
        console.error("Failed to load customer branding config", error);
        if (isMounted) {
          setCustomerConfig(null);
        }
      }
    }

    loadCustomerConfig();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        toggleTheme,
        theme,
        isDark,
        user,
        chatbotAlign,
        changeChatbotAlign,
        storeTemplateName,
        setStoreTemplateName,
        templateJson,
        setTemplateJson,
        showModal,
        setShowModal,
        showModalMsg,
        setShowModalMsg,
        loading,
        setLoading,
        templateName,
        setTemplateName,
        fetchClientTemplates,
        setFetchClientTemplates,
        selectedGroup,
        setSelectedGroup,
        filteredFetchClientTemplates,
        setFilteredFetchClientTemplates,
        userRole,
        cognitoGroups,
        fetchTemplateList,
        lobText,
        setLOBText,
        documents,
        setDocuments,
        lobCodesList,
        setLobCodesList,
        storeWidgetName,
        setStoreWidgetName,
        listOfLobs,
        setListOfLobs,
        confirmTemplateSave,
        setconfirmTemplateSave,
        isEditMode,
        setIsEditMode,
        showConfirm,
        setShowConfirm,
        onConfirmCallback,
        setOnConfirmCallback,
        handleClose,
        tickedEntities,
        setTickedEntities,
        storeSelectedRule,
        setStoreSelectedRule,
        storedNavigate,
        setStoredNavigate,
        activeStepName,
        setActiveStepName,
        templateJsonData,
        setTemplateJsonData,
        selectedTemplateRules,
        setSelectedtemplateRules,
        initializeTemplateAndRules,
        activeStep,
        setActiveStep,
        extractToolData,
        setExtractToolData,
        sidebarOpen,
        setSidebarOpen,
        rulesData,
        setRulesData,
        templateCount,
        setTemplateCount,
        maxTemplateAllowedCount,
        setMaxTemplateAllowedCount,
        tempStoreSelectedRule,
        setTempStoreSelectedRule,
        searchText,
        setSearchText,
        globalSearchtext,
        setGlobalSearchtext,
        searchMode,
        setSearchMode,
        filterModalState,
        setFilterModalState,
        displayElement,
        userGroups,
        userGroupsLoaded,
        viewType,
        setViewType,
        displaySubHistFromDate,
        displaySubHistToDate,
        dateRange,
        setDateRange,
        durationInDays,
        setDurationInDays,
        isInitialDateSet,
        setIsInitialDateSet,
        procStatus,
        setProcStatus,
        clientSideFilters,
        setClientSideFilters,
        isFilterActive,
        setIsFilterActive,
        customerConfig,
        setUserGroups,
        fetchUserGroups,
        fetchLOBCodeList,
        fetchCountryCodes,
        fetchDeclineCodeList,
        submissionName,
        setSubmissionName,
        submissionIdentifier,
        setSubmissionIdentifier,
        enableSelectedTemplate,
        setEnableSelectedTemplate,
        lobCodeOptions,
        setLOBCodeOptions,
        assocCtryCodeOptions,
        setAssocCtryCodeOptions,
        mapTemplateOptions,
        isInvalidSubmissionId,
        disallowSubmission,
        filteredUserGroups,
        showCountryCodes,
        setShowCountryCodes,
        lobCodeValidationEnabled,
        setLobCodeValidationEnabled,
        templateOptions,
        setTemplateOptions,
        isAllowedExtension,
        mcUploadExt,
        setMCUploadExt,
        showModalSelectTemplate,
        setShowModalSelectTemplate,
        reprocessDocument,
        allItems,
        menuItems,
        showNewSubmissionButton,
        isChatbotEnabled,
        isSubmissionModalOpen,
        setIsSubmissionModalOpen,
        businessProcessItems,
        documentObj,
        setDocumentObj,
        isChatModalOpen,
        setIsChatModalOpen,
        templateType,
        setTemplateType,
        submitTemplateName,
        setSubmitTemplateName,
        validateDocuments,
        formData,
        setFormData,
        initialFormState,
        selectedTemplate,
        setSelectedTemplate,
        handleFileUploads,
        fetchLatestData,
        setFetchLatestData,
        enableTemplate,
        setEnableTemplate,
        selectedUploadFile,
        setSelectedUploadFile,
        closeUploadModal,
        isModalOpen,
        setIsModalOpen,
        openModalRowId,
        setOpenModalRowId,
        modalAttachments,
        setModalAttachments,
        template,
        setTemplate,
        selectedFileName,
        setSelectedFileName,
        isMulti,
        selectedEntityDocPriorityList,
        setSelectedEntityDocPriorityList,
        originalTemplateSnapshot,
        setOriginalTemplateSnapshot,
        qaToolStatus,
        setQaToolStatus,
        defaultProcStatus,
        setDefaultProcStatus,
        browserByApp,
        ingestMyData,
        updatedTableHeading,
        setUpdatedTableHeading,
        columnHeader,
        setColumnHeader,
        utcTimeConvert,
        setUtcTimeConvert,
        filterSearchTerm,
        setFilterSearchTerm,
        filterSearchResults,
        setFilterSearchResults,
        filterPrevSearchTermRef,
        filterSearchColumn,
        setFilterSearchColumn,
        fetchData,
        filteredTileViewDocs,
        setFilteredTileViewDocs,
        setSelectedLabels,
        selectedLabels,
        activeFilters,
        setActiveFilters,
        lobCode,
        setLOBCode,
        modifiedManageCol,
        setModifiedManageCol,
        groupedPosition,
        setGroupedPosition
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useAppThemeContext = () => {
  return useContext(ThemeContext);
};
